import React, { useState, useEffect, useRef } from 'react';
import Contact from '../../components/Career/Contact';
import Navbar from '../../components/Header';
import Footer from '../../components/Footer';
import CareerPost from '../../components/Career/CareerPost';
import axios from 'axios';
import HeroSection from '../../components/Career/HeroSection';
import Promise from '../../components/Career/Promise';
import Enquiry from '../../components/Career/Enquiry';
import Modal from '../../components/Career/Modal';

function Career() {
  const [careerPost, setCareerPost] = useState(null);
  const [positionVal, setPositionVal] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const vacanciesRef = useRef(null);

  useEffect(() => {
    const fetchCareerPosts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/careerPost`);
        setCareerPost(response.data);
        setPositionVal(response.data.map((res) => {
          return res.id;
        }))
        console.log("Fetched career posts:", response.data);
      } catch (err) {
        console.error("Error fetching career posts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCareerPosts();
  }, []);

  return (
    <div>
      <Navbar diffHeader={true} />
      <HeroSection scrollToRef={vacanciesRef} openModal={() => setShowModal(true)} />
      <Contact positionVal={positionVal} />
      <Enquiry careerPost={careerPost} positionVal={positionVal} />

      {loading ? (
        <div className="text-center my-10 text-gray-500">Loading career posts...</div>
      ) : (
        <div ref={vacanciesRef}>
          <CareerPost careerPost={careerPost} />
        </div>
      )}

      {/* Modal only shown when true */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 z-50 flex justify-center items-center px-4">
          <div className="bg-white p-6 rounded-lg w-full max-w-xl relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-black"
            >
              &times;
            </button>
            <Modal positionVal={positionVal} />
          </div>
        </div>
      )}


      <Promise />
      <Footer />
    </div>
  );
}

export default Career;
